import React, { useCallback, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import { InputWithPrefixSufix } from 'DesignSystem'

import { addAlert } from 'Store/Actions/alerts.action'
import { companyAvailability } from 'Store/Actions/Company/domain.action'

import type { DataCompanyCreateContentManagerI } from 'Components/FirstSetupFlow'

import type { AuxStepContentManagerI } from 'Hooks/useContentManager.hook'
import useDebounce from 'Hooks/useDebounce.hook'

import { flat } from 'Helpers/String.helper'
import { cleanSubdomain } from 'Helpers/Url.helper'

type NameCompanyCreateDialogPropsI =
  AuxStepContentManagerI<DataCompanyCreateContentManagerI>;

const SlugWorkspaceField = ({
  setData,
  dataContentManager,
  setEnableNext
}: NameCompanyCreateDialogPropsI) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const suggestionSlug = flat((dataContentManager.name || '').trim())

  const ERROR_SLUG_SIZE = intl.formatMessage({ id: 'Este slug ultrapassa os 24 caracteres.' })
  const ERROR_UNAVAIABLE = intl.formatMessage({ id: 'Este slug já está em uso, por favor escolha outra opção.' })

  const { slug, isValidSlug } = dataContentManager
  const [isLoading, setIsLoading] = useState(true)
  const [errorMessage, setErrorMessage] = useState('')
  const [alreadyTyping, setAlreadyTyping] = useState(!!(typeof slug === 'string' && slug.length > 0))
  const [slugLocal, setSlugLocal] = useState(slug)
  const slugDebounce = useDebounce(slugLocal ?? '', 500)

  const validate = (slug: string) => {
    let isValid = true
    if (typeof slug === 'string' && slug.length > 24) {
      isValid = false
      setErrorMessage(ERROR_SLUG_SIZE)
    }
    setData({
      slug,
      isValidSlug: isValid
    })
    return isValid
  }

  const checkSuggestion = useCallback(async () => {
    if (alreadyTyping) return
    if (validate(suggestionSlug) === false) return
    // if (
    //   (slug === '' || slug === undefined) &&
    //   suggestionSlug !== '' &&
    //   suggestionSlug !== undefined
    // ) {
    const response = await companyAvailability(suggestionSlug)
    const isValid = response.status === 'success'

    setErrorMessage('')

    if (isValid) {
      setErrorMessage('')
      setData({
        slug: suggestionSlug,
        isValidSlug: isValid
      })
      setSlugLocal(suggestionSlug)
    } else {
      checkAvailabilityDomain(suggestionSlug + '-1')
      setErrorMessage(ERROR_UNAVAIABLE)
    }
    // }
    setIsLoading(false)
  }, [dataContentManager.name, suggestionSlug])

  useEffect(() => {
    checkSuggestion()
  }, [dataContentManager.name])

  async function checkAvailabilityDomain (slug: string) {
    try {
      setErrorMessage('')

      if (validate(slug) === false) return

      if (slug === '' || slug === undefined) {
        setErrorMessage('')
        return
      }

      const response = await companyAvailability(slug)
      const isValid = response.status === 'success'
      if (isValid === false) {
        setErrorMessage(ERROR_UNAVAIABLE)
      }
      setData({
        slug,
        isValidSlug: isValid
      })
    } catch (e: any) {
      dispatch(addAlert({ title: e.message, type: 'error' }))
      setData({
        slug,
        isValidSlug: false
      })
    }
  }

  useEffect(() => {
    setSlugLocal(slug || '')
  }, [isValidSlug, slug])

  useEffect(() => {
    checkAvailabilityDomain(slugDebounce)
  }, [slugDebounce])

  const setSlug = (slug: string) => {
    setSlugLocal(cleanSubdomain(slug))
  }

  return (
    <div>
      <label className="fw-bold">
        {intl.formatMessage({ id: 'Url do Workspace:' })}{' '}
        <span className="text-error">*</span>:
      </label>
      <InputWithPrefixSufix
        error={errorMessage !== ''}
        className="mt-2"
        label={intl.formatMessage({ id: 'URL' })}
        value={slugLocal}
        onChange={(event: any) => {
          setAlreadyTyping(true)
          setSlug(event?.target?.value.replaceAll(' ', ''))
        }}
        preffix={'https://'}
        suffix={'.' + localStorage.getItem('odash-app:domain-suffix')}
        isLoading={isLoading}
        data-cy="company-domain"
      />
      {errorMessage !== '' ? (
        <small className='text-error'>{errorMessage}</small>
      ) : (
        <small className="caption1">
          {intl.formatMessage({ id: 'Apenas letras minúsculas, números ou hifens' })}
        </small>
      )
        }
    </div>
  )
}

export default SlugWorkspaceField
